module.exports = __webpack_public_path__ + "img/Lancer_logo.85353400.png";